module.exports = __webpack_public_path__ + "assets/img/37_1527.2d8cc921.jpg";